/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import React from 'react';
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Ameer Hamza",
  title: "Hi all, I'm Hamza",
  subTitle2: "I turn business ideas into products that ship.",
  subTitle: emoji(
    "As a Senior iOS Developer, I specialize in building and leading modular mobile products from concept to launch with end-to-end ownership. With over 20 production apps delivered—including products with 1M+ downloads—I combine technical expertise in Swift, SwiftUI, UIKit, and Objective-C with a focus on architecture, performance, and release quality.\n\nFrom crafting intuitive user interfaces to implementing complex backend integrations, I focus on delivering robust, seamless solutions that provide real value. I am currently available for senior roles, freelance, and consulting engagements."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ogIFL5imsbrTvDuq8enXng8_JMypSCIu/view?usp=share_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ameerhamzabeliever",
  linkedin: "https://linkedin.com/in/ameer-hamza-2a203620b",
  gmail: "ameerhamza.pro001@gmail.com",
  whatsapp: "https://wa.me/393921665175",


  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Technology Stack ⚙️",
  subTitle: "Organized by capability — because tools serve the solution, not the other way around",
  skills: [
    "⚡ iOS-native development in Swift, SwiftUI, UIKit, and Objective-C — extended with Dart for cross-platform reach — built for performance and platform fluency",
    <React.Fragment key="architecture">
      ⚡ Architecture patterns applied by context:<br />
      &nbsp;&nbsp;✔ MVVM, MVC, MVP, MVI for structured, testable codebases<br />
      &nbsp;&nbsp;✔ Clean Architecture and VIPER for large-scale, modular systems
    </React.Fragment>,
    "⚡ AI & ML capabilities via TensorFlow, OpenAI API, and NLP integration — for intelligent, context-aware features",
    "⚡ Backend & data layer: Firebase, Core Data, SQL, and REST APIs — reliable, scalable, and offline-ready",
    "⚡ DevOps & quality: CI/CD pipelines, Fastlane, Automated Testing, TDD, Crashlytics, and Analytics — for consistent, production-grade delivery"
  ],


  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    // Languages
    {
      skillName: "Swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "SwiftUI",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "UIKit",
      fontAwesomeClassname: "fab fa-uikit"
    },
    {
      skillName: "Objective-C",
      fontAwesomeClassname: "fab fa-apple"
    },
    {
      skillName: "Dart",
      fontAwesomeClassname: "fa-solid fa-code"
    },
    // Architecture Patterns
    {
      skillName: "MVVM",
      fontAwesomeClassname: "fas fa-th-large"
    },
    {
      skillName: "MVC",
      fontAwesomeClassname: "fas fa-cubes"
    },
    {
      skillName: "MVP",
      fontAwesomeClassname: "fab fa-hive"
    },
    {
      skillName: "MVI",
      fontAwesomeClassname: "fa-solid fa-diagram-project"
    },
    {
      skillName: "Clean Architecture",
      fontAwesomeClassname: "fas fa-th"
    },
    // Data & Backend
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fa-solid fa-fire-flame-curved"
    },
    {
      skillName: "Core Data",
      fontAwesomeClassname: "fa-solid fa-database"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "bi bi-filetype-sql"
    },
    {
      skillName: "REST APIs",
      fontAwesomeClassname: "fa-solid fa-plug"
    },
    // AI & ML
    {
      skillName: "TensorFlow",
      fontAwesomeClassname: "fa-solid fa-brain"
    },
    {
      skillName: "OpenAI API",
      fontAwesomeClassname: "fa-solid fa-robot"
    },
    {
      skillName: "NLP Integration",
      fontAwesomeClassname: "fa-solid fa-comment-dots"
    },
    // Testing & Quality
    {
      skillName: "Unit Testing",
      fontAwesomeClassname: "fa-solid fa-cubes-stacked"
    },
    {
      skillName: "TDD",
      fontAwesomeClassname: "fa-solid fa-arrows-spin"
    },
    {
      skillName: "Automated Testing",
      fontAwesomeClassname: "fa-solid fa-vial-circle-check"
    },
    {
      skillName: "Crashlytics",
      fontAwesomeClassname: "fa-solid fa-bug-slash"
    },
    // DevOps & Distribution
    {
      skillName: "CI/CD Pipelines",
      fontAwesomeClassname: "fa-solid fa-code-branch"
    },
    {
      skillName: "Fastlane",
      fontAwesomeClassname: "fa-solid fa-rocket"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fa-brands fa-git-alt"
    },
    {
      skillName: "GitHub",
      fontAwesomeClassname: "fa-brands fa-github"
    },
    {
      skillName: "In-App Purchases",
      fontAwesomeClassname: "fa-solid fa-cart-shopping"
    },
    {
      skillName: "App Submission",
      fontAwesomeClassname: "fab fa-app-store-ios"
    },
    // Tools & Workflow
    {
      skillName: "Jira",
      fontAwesomeClassname: "fa-brands fa-jira"
    },
    {
      skillName: "Azure DevOps",
      fontAwesomeClassname: "fa-brands fa-windows"
    },
    {
      skillName: "Agile",
      fontAwesomeClassname: "fa-solid fa-group-arrows-rotate"
    },
    {
      skillName: "Analytics",
      fontAwesomeClassname: "fa-solid fa-chart-line"
    },
    {
      skillName: "MS Office",
      fontAwesomeClassname: "fa-solid fa-file-word"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Sargodha",
      logo: require("./assets/images/sargodha.jpeg"),
      subHeader: "Bachelor in Computer Science",
      duration: "(October 2017 - June 2021)"
    },
    {
      schoolName: "Mastering SwiftUI",
      logo: require("./assets/images/swiftui.png"),
      subHeaderKey: "education.udemyCertification",
      duration: "2025"
    },
    {
      schoolName: "Mobile App Marketing & ASO",
      logo: require("./assets/images/aso-letter-logo-design-on-white-background-vector-41762866.avif"),
      subHeaderKey: "education.udemyCertification",
      duration: "2024"
    }

  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "iOS Development", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Swift",
      progressPercentage: "90%"
    },
    {
      Stack: "Objective-C",
      progressPercentage: "70%"
    },
    {
      Stack: "UIKit",
      progressPercentage: "90%"
    },
    {
      Stack: "SwiftUI",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Additional skill categories
const leadershipStack = {
  title: "Leadership & Methodology",
  icon: "👥",
  experience: [
    {
      Stack: "Team Leadership",
      progressPercentage: "90%"
    },
    {
      Stack: "Code Review",
      progressPercentage: "90%"
    },
    {
      Stack: "Technical Mentoring",
      progressPercentage: "85%"
    },
    {
      Stack: "Agile/Scrum",
      progressPercentage: "85%"
    }
  ]
};

const codingPhilosophyStack = {
  title: "Vibe Coding Philosophy",
  icon: "✨",
  experience: [
    {
      Stack: "Clean Code Principles",
      progressPercentage: "90%"
    },
    {
      Stack: "User-Centric Development",
      progressPercentage: "90%"
    },
    {
      Stack: "Performance Optimization",
      progressPercentage: "85%"
    },
    {
      Stack: "Continuous Learning",
      progressPercentage: "95%"
    }
  ]
};

const crossPlatformStack = {
  title: "Cross-Platform & Expanding",
  icon: "📱",
  experience: [
    {
      Stack: "AI Integration (MediaPipe)",
      progressPercentage: "70%"
    },
    {
      Stack: "Android/Kotlin",
      progressPercentage: "50%"
    },
    {
      Stack: "Flutter/Dart",
      progressPercentage: "55%"
    },
    {
      Stack: "n8n Automation",
      progressPercentage: "60%"
    }
  ]
};

const appPublishingStack = {
  title: "App Publishing & Distribution",
  icon: "🚀",
  experience: [
    {
      Stack: "App Store Connect",
      progressPercentage: "85%"
    },
    {
      Stack: "App Store Optimization",
      progressPercentage: "75%"
    },
    {
      Stack: "Google Play Console",
      progressPercentage: "50%"
    },
    {
      Stack: "Beta Testing",
      progressPercentage: "80%"
    }
  ]
};

// Work experience section - Last updated: 2025-07-24

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior iOS Application Developer",
      company: "Joblogic",
      companylogo: require("./assets/images/jobLogic.png"),
      desc: "Joined as a Mid-Level iOS Developer, transitioned into a Senior role",
      heading: "Key Responsibilities & Achievements",
      descBullets: [
        "Developed and maintained iOS apps using Swift, Objective-C, MVVM, Clean Swift, and Core Data",
        "Migrated Core Data implementation to SQLite and led the migration team",
        "Stabilized the app by fixing critical bugs and achieved a 100% crash-free experience in production",
        "Refactored 80% of the legacy Joblogic codebase, resolving critical crashes and bugs",
        "Also worked remotely with Joblogic UK and Vietnam team, ensuring consistent delivery and quality",
        "Contributed to the Flutter app using Dart, Clean Architecture, and GetX"
      ],
      toolsSection: {
        heading: "Tools & Skills Gained:",
        items: [
          "JIRA, Azure DevOps, Git",
          "SwiftUI (personal projects)",
          "Cross-platform and clean architecture expertise"
        ]
      }
    },
    {
      role: "iOS Application Developer",
      company: "YumyApps",
      companylogo: require("./assets/images/yamm.png"),
      desc: "Joined as a Mid-level iOS Developer, leading end-to-end app development—from initial build to App Store deployment, maintenance, and feature enhancements",
      heading: "Key Responsibilities & Achievements:",
      descBullets: [
        "Built and maintained iOS applications using Swift and UIKit",
        "Enhanced app functionality and resolved critical bugs to stabilize the product",
        "Set the foundation for a new product with clean architecture and reusable components",
        "Utilized Core Data for efficient local storage and persistence",
        "Applied MVVM and MVC architecture patterns for scalable code",
        "Collaborated with cross-functional teams for timely delivery and quality assurance",
      ]
    },
    {
      role: "iOS Application Developer ",
      company: "Vespert Tech",
      companylogo: require("./assets/images/Vespert Tech.png"),
      desc: "Began my iOS development career at Vespert Tech, responsible for building and maintaining iOS applications",
      heading: "Key Responsibilities & Achievements:",
      descBullets: [
        "Delivered over 15+ apps, helping startups grow and launch successfully",
        "Built and launched iOS apps from scratch using Swift, Objective-C, and UIKit",
        "Integrated key features like In-App Purchases, WebSockets, and Google AdMob",
        "Improved legacy codebases by adopting MVVM/MVC architecture and refactoring",
        "Collaborated in Agile teams with active participation in stand-ups and sprint planning",
        "Recognized as a top-performing team member for adding value to the company",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "My Projects 🛠️",
  subtitle: "Startups and companies I’ve contributed to by building and shaping their technology from the ground up",
  projects: [
    {
      image: require("./assets/images/Joblogic_Project.png"),
      projectName: "Joblogic",
      projectDesc: "Field service management software suite for SaaS",
      techStack: "Swift, Objective-C, MVVM, MVP, Clean Architecture, Core Data, SQLite, Flutter (Dart, Clean, GetX), Kotlin",
      footerLink: [
        {
          name: "View Project",
          url: "https://apps.apple.com/pk/app/joblogic/id1084286430"
        },

      ]
    },
    {
      image: require("./assets/images/Jalsah_Project.png"),
      projectName: "Jalsah",
      projectDesc: "Social interaction app for real-time chatting, interactive challenges, and games",
      techStack: "Swift, MVVM, UIKit, Google AdMob, Custom Animations, In-App Purchases",
      footerLink: [
        {
          name: "View Project",
          url: "https://apps.apple.com/pk/app/jalsah-جلسة/id1106410643"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/Family Time_Project.png"),
      projectName: "FamilyTime",
      projectDesc: "Parental control app with monitoring and blocking capabilities",
      techStack: "Swift, Objective-C, MVC, In-App Purchases",
      footerLink: [
        {
          name: "View Project 1",
          url: "https://apps.apple.com/pk/app/familytime-parental-controls/id981066103"
        },
        {
          name: "View Project 2",
          url: "https://apps.apple.com/pk/app/familytime-jr/id1002010477"
        }
      ]
    },
    {
      image: require("./assets/images/Alfalah_Project.png"),
      projectName: "Alfalah",
      projectDesc: "Islamic lifestyle app featuring Quran, prayers, duas, Qibla direction, and Islamic calendar",
      techStack: "Swift, UIKit, Core Data, MVVM",
      footerLink: [
        {
          name: "View Project",
          url: "https://apps.apple.com/pk/app/alfalah-quran-athan-prayer/id1631108236"
        },

      ]
    },
    {
      image: require("./assets/images/Get An Expert_Project.png"),
      projectName: "Get An Expert",
      projectDesc: "Service marketplace app connecting providers and clients",
      techStack: "Swift, MVC, Firebase, Chat, Audio/Video Calls, Online Payment"
    },
    {
      image: require("./assets/images/Quokka_Project.png"),
      projectName: "Quokka",
      projectDesc: "Social matchmaking app for one-minute voice calls",
      techStack: "Swift, UIKit, MVVM, Social logins, Custom Animations, WebSockets",
    },
    {
      image: require("./assets/images/doc Scanner_Project.png"),
      projectName: "Scanner App",
      projectDesc: "Document scanning, editing, and PDF generation utility",
      techStack: "Swift, MVC, Core Data",
      footerLink: [
        {
          name: "View Project",
          url: "https://apps.apple.com/pk/app/scanner-app/id1291962681"
        },

      ]
    },
    {
      image: require("./assets/images/SKUScanner_Project.png"),
      projectName: "SKU Scanner",
      projectDesc: "An inventory management application that allows users to manage stock, generate and scan barcodes, maintain records, and create detailed reports for tracking and analysis",
      techStack: "Swift, MVC, BarCodescanner, BarCode Generator, iOT",
    },
    {
      image: require("./assets/images/Community Maker_Project.png"),
      projectName: "Community Maker",
      projectDesc: "Social app enabling users to post help requests within local communities",
      techStack: "Swift, UIKit, MVC, Deep Linking",
    },
    {
      image: require("./assets/images/Pisiffik.jpg"),
      projectName: "Pisiﬃk",
      projectDesc: "Modern e-commerce app with online grocery shopping, in-store pickup, home delivery, and a built-in loyalty rewards system",
      techStack: "Swift, UIKit, MVVM, Google Maps, Stripe Integration",
      footerLink: [
        {
          name: "View Project",
          url: "https://apps.apple.com/pk/app/pisiffik/id1637092101"
        },

      ]
    },
    {
      image: require("./assets/images/My360Key.jpg"),
      projectName: "My 360 Key",
      projectDesc: "App for real-time discovery of nearby shops with map-based navigation and smart door unlocking using MapKit and smart lock APIs",
      techStack: "Swift, MVVM, MapKit, NFC",
      footerLink: [
        {
          name: "View Project",
          url: "https://apps.apple.com/pk/app/my360key/id6449696077"
        },

      ]
    },
    {
      image: require("./assets/images/LifeSign.webp"),
      projectName: "Life Sign",
      projectDesc: "A secure, communication-focused mobile app with real-time messaging to help users stay connected with friends and family through private, instant conversations",
      techStack: "Swift, UIKit, MVC, Social Login SDKs, WebSockets",
      footerLink: [
        {
          name: "View Project",
          url: "https://apps.apple.com/us/app/lifesign/id1499793115"
        },

      ]
    },
    {
      image: require("./assets/images/Flovso.png"),
      projectName: "Flovso App",
      projectDesc: "A social platform for the fashion industry, enabling users to share opinions, engage in discussions, and get community feedback on trends, brands, and designers—featuring user-generated content, likes, comments",
      techStack: "Swift, UIKit, MVC",
      footerLink: [
        {
          name: "View Project",
          url: "https://apps.apple.com/pk/app/flovso/id1615357911"
        },

      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievements Section

const achievementSection = {
  title: "Achievements And Certifications 🏆",
  subtitle: "Achievements, certifications, award letters and some cool stuff that I have done",
  
  achievementsCards: [
    {
      title: "Apple Certified iOS App Development with Swift",
      subtitle: "Completed Apple's official curriculum focused on iOS development using Swift. Gained hands-on experience with app architecture, Swift programming, UI design, and deployment. Participated through the Swift Student Challenge and affiliated Apple learning initiatives.",
      image: require("./assets/images/appleCertificate.png"),
      imageAlt: "Apple iOS Development Certificate"
    },
    {
      title: "Hackathon Winner at AngelHack",
      subtitle: "Secured first place at AngelHack for developing a mobile application that provided real-time emergency assistance and geo-tracking. Led the iOS development, implemented scalable architecture using Swift and MVVM, and presented the solution to a panel of industry experts.",
      image: require("./assets/images/HackathonCertificate.png"),
      imageAlt: "Hackathon Winner Certificate"
    },
    {
      title: "Speaker at Mobile Dev Meetups & Conferences",
      subtitle: "Delivered technical talks on iOS architecture patterns including MVVM, Clean Swift, and modular app design. Shared insights on scalable code practices, real-world debugging strategies, and cross-platform development using Flutter and SwiftUI at various local meetups and online sessions.",
      image: require("./assets/images/leaderCertificate.jpg"),
      imageAlt: "Leadership and Speaking Certificate"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};



// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

// Stats Section
const statsSection = {
  title: "Fast Facts 📊",
  subtitle: "",
  display: true, // Set false to hide this section, defaults to true
  data: [
    {
      icon: "⏰",
      number: "6+",
      label: "Years Experience"
    },
    {
      icon: "📋",
      number: "20+",
      label: "Projects Delivered"
    },
    {
      icon: "📈",
      number: "50%",
      label: "UX Improvement"
    },
    {
      icon: "🤝",
      number: "15+",
      label: "Clients Collaborated With"
    },
    {
      icon: "🤖",
      number: "2+",
      label: "AI Integrations"
    },
    {
      icon: "✅",
      number: "100%",
      label: "System Uptime"
    }
  ]
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all",
  number: "+393921665175",
  email_address: "ameerhamza.pro001@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

// How I Work Section

const howIWork = {
  display: true,
  phases: [
    {
      icon: "🔍",
      titleKey: "howIWork.phase1.title",
      descKey: "howIWork.phase1.desc"
    },
    {
      icon: "🎨",
      titleKey: "howIWork.phase2.title",
      descKey: "howIWork.phase2.desc"
    },
    {
      icon: "💻",
      titleKey: "howIWork.phase3.title",
      descKey: "howIWork.phase3.desc"
    },
    {
      icon: "🚀",
      titleKey: "howIWork.phase4.title",
      descKey: "howIWork.phase4.desc"
    },
    {
      icon: "📈",
      titleKey: "howIWork.phase5.title",
      descKey: "howIWork.phase5.desc"
    }
  ]
};

// What I Deliver Section

const whatIDeliver = {
  display: true,
  items: [
    {
      icon: "💡",
      titleKey: "whatIDeliver.item1.title",
      descKey: "whatIDeliver.item1.desc"
    },
    {
      icon: "🗂️",
      titleKey: "whatIDeliver.item2.title",
      descKey: "whatIDeliver.item2.desc"
    },
    {
      icon: "📱",
      titleKey: "whatIDeliver.item3.title",
      descKey: "whatIDeliver.item3.desc"
    },
    {
      icon: "🔌",
      titleKey: "whatIDeliver.item4.title",
      descKey: "whatIDeliver.item4.desc"
    },
    {
      icon: "🧠",
      titleKey: "whatIDeliver.item5.title",
      descKey: "whatIDeliver.item5.desc"
    },
    {
      icon: "🚀",
      titleKey: "whatIDeliver.item6.title",
      descKey: "whatIDeliver.item6.desc"
    },
    {
      icon: "🛡️",
      titleKey: "whatIDeliver.item7.title",
      descKey: "whatIDeliver.item7.desc"
    },
    {
      icon: "📈",
      titleKey: "whatIDeliver.item8.title",
      descKey: "whatIDeliver.item8.desc"
    }
  ]
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  leadershipStack,
  codingPhilosophyStack,
  crossPlatformStack,
  appPublishingStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
  statsSection,
  whatIDeliver,
  howIWork
};
